<div class="success-modal">
    <mapfre-modal [modalOptions]="uploadDocModalOptions" [hideModal]="hideModal"
        (hideModalOutput)="hideModalAction()"
        (click)="hideOnClick($event)">
        <div class="modal-body mb-2 pb-4">
            <div class="margin-top mt16 text-center">
                <div>            
                    <ng-container *ngIf="!isAcmic; else acmicCloseIcon">
                        <img src="./assets/img/images/icon-check-circle-mapfre.svg" alt="check circle icon" />
                    </ng-container>
                    <ng-template #acmicCloseIcon>
                        <img src="./assets/img/images/icon-check-circle-acmic.svg" alt="check circle icon" />
                    </ng-template>            
                </div>
                <h1 class="bigger-font-size mb-3 mt-3"> {{ 'Documents successfully uploaded' | translate }}</h1>
                <div class="invalid-format margin-bottom mb2 lh-normal">{{ 'UPLOAD_SUCCESS_SUB_TEXT'| translate }}</div>
            </div>
            <hr class="ma-hr-tag margin-top mt32 margin-bottom mb32">
            
            <div class="row text-right margin-top mt24">    
                <div class="col show-btn-order" [ngClass]="{'justify-content-center pl-0 upload-btn-success-ml': isAcmic}">
                    <mapfre-button
                    (click)="hideModalAction()"
                    additionalClasses="ghost secondary small-btn modal-small-btn"
                    >{{ "Upload more documents" | translate }}
                  </mapfre-button>
                  <mapfre-button
                    (click)="gotoDocuments()"
                    additionalClasses="basic primary small-btn modal-small-btn"
                    >{{ "Go to documents" | translate }}
                  </mapfre-button>          
                </div>
              </div>
        </div>
    </mapfre-modal>
</div>